import Vue from 'vue'
import Router from 'vue-router'
const Home = resolve => require(['../pages/home/home.vue'], resolve);
const content = resolve => require(['../pages/home/text'], resolve);
const commentReply = resolve => require(['../pages/home/commentReply'], resolve);
//评估模块
const testUserList = resolve => require(['../pages/test/testUserList'], resolve);
const testBack = resolve => require(['../pages/test/testBack'], resolve);
const testUserBack = resolve => require(['../pages/test/testUserBack'], resolve);
const reportList = resolve => require(['../pages/test/reportList'], resolve);
const userEdit = resolve => require(['../pages/test/userEdit'], resolve);
const wanShan = resolve => require(['../pages/test/testWShan'], resolve);
const testWxsao = resolve => require(['../pages/test/wxsao'], resolve) //添加用户方式
const wxsaoInfo = resolve => require(['../pages/test/wxsaoInfo'], resolve) //完善资料
const qrUserOver = resolve => require(['../pages/test/components/qrUserover'], resolve) //完善资料
const testfail = resolve => require(['../pages/test/wxsaofail'], resolve) //不是你的二维码
const testuserNews = resolve => require(['../pages/test/userNews'], resolve); //个人信息
const ReportPlan = resolve => require(['../pages/test/ReportPlan.vue'], resolve); //报告详细方案
const testHome = resolve => require(['../pages/test/testHome'], resolve); //开始评估首页
const testTransition = resolve => require(['../pages/test/testTransition'], resolve); //舌诊成功，进入问诊阶段
const testTipImg = resolve => require(['../pages/test/testTipImg'], resolve); //拍照前照片提示
const testQuestion = resolve => require(['../pages/test/testQuestion'], resolve); //问诊
const reportdetails = resolve => require(['../pages/test/reportDetails'], resolve); //报告详情页
const reportdetails2 = resolve => require(['../pages/test/reportDetails2'], resolve); //报告详情页
const qrUserComplete = resolve => require(['../pages/test/components/qrUserComplete'], resolve); //微信扫码完成
const testSearch = resolve => require(['../pages/test/userSearch'], resolve); //用户搜索
const testRecord = resolve => require(['../pages/test/testRecord'], resolve); //用户评估记录
const testReList = resolve => require(['../pages/test/myReList'], resolve); //用户自己评估记录
const testmyReport = resolve => require(['../pages/test/myReport'], resolve);
//公司二维码
const companyCheck = resolve => require(['../pages/company/companyCheck'], resolve); //公司认证
const company = resolve => require(['../pages/company/company.vue'], resolve); //公司二维码
const companyAfter = resolve => require(['../pages/company/companyAfter.vue'], resolve); //公司二维码
//个人中心
const personal = resolve => require(['../pages/personal/personal'], resolve); //个人中心
const personalSet = resolve => require(['../pages/personal/personalSet'], resolve); //个人设置
const quanmai = resolve => require(['../otherpage/quanmai'], resolve); //关于泉脉
const Mycard = resolve => require(['../pages/pay/mycard.vue'], resolve) //我的卡包
const MyFailCard = resolve => require(['../pages/pay/myFailCard.vue'], resolve) //我的无效卡包
const sendCard = resolve => require(['../pages/pay/sendCard.vue'], resolve) //我的卡包
const payCard = resolve => require(['../pages/pay/payCard.vue'], resolve) //兑换充值吗
const cardrecord = resolve => require(['../pages/pay/cardrecord'], resolve) //卡包使用记录
const manager = resolve => require(['../pages/personal/personalmanager'], resolve); //授权管理
const feedBack = resolve => require(['../pages/personal/feedback'], resolve); //帮助与反馈
const helpFeed = resolve => require(['../pages/personal/helpfeed'], resolve); //意见与反馈
const psDetails = resolve => require(['../pages/personal/personalDetails'], resolve)
const feedQuestion = resolve => require(['../pages/personal/feedquestion'], resolve); //帮助问题
//积分任务中心
const jobcenter = resolve => require(['../pages/jifen/jobcenter'], resolve)
const Interule = resolve => require(['../pages/jifen/Interule'], resolve)
const Integration = resolve => require(['../pages/jifen/integration'], resolve)
    //医师模块
const psDetailsDoc = resolve => require(['../pages/personal/psDetailsDoc'], resolve)
const psDetailsDoc2 = resolve => require(['../pages/personal/psDetailsDoc2'], resolve)
const personalDocPrice = resolve => require(['../pages/personal/personalDocPrice'], resolve)
    //礼品
const pay = resolve => require(['../pages/pay/payMethods'], resolve) //支付页面,最新
const paid = resolve => require(['../pages/pay/paid'], resolve) //其他支付完成
const payWeixin = resolve => require(['../pages/pay/payWeixin'], resolve) //微信支付完成
const homearticle = resolve => require(['../pages/home/article.vue'], resolve)
    //健康趋势页面
const healthChart = resolve => require(['../pages/find/healthChart'], resolve)
const iosandroid = resolve => require(['../pages/find/iosandroid'], resolve)
    //缺省页
const making = resolve => require(['../components/making.vue'], resolve)
    //健康报告
// const newReport = resolve => require(['../pages/newreport/newReport.vue'], resolve)
// const sendReport = resolve => require(['../pages/newreport/sendReport.vue'], resolve)
// const newReportPlan = resolve => require(['../pages/newreport/newReportPlan.vue'], resolve)
const Report = resolve => require(['../pages/newreport/report.vue'], resolve)
    //健康回复
const cstIndex = resolve => require(['../pages/consult/CstIndex'], resolve)
const docSearch = resolve => require(['../pages/consult/docSearch'], resolve)
const myCst = resolve => require(['../pages/consult/myCst'], resolve)
const cstDocIndex = resolve => require(['../pages/consult/cstDocIndex'], resolve)
const imgCst = resolve => require(['../pages/consult/imgCst'], resolve)
const phoneCst = resolve => require(['../pages/consult/phoneCst'], resolve)
const phoneOrder = resolve => require(['../pages/consult/phoneOrder'], resolve) //
const phoneOrderSubmit = resolve => require(['../pages/consult/phoneOrder/submit'], resolve) //
const phoneOrderType = resolve => require(['../pages/consult/phoneOrder/orderType'], resolve) //
const docCstList = resolve => require(['../pages/consult/docCstList'], resolve) //
const docImgList = resolve => require(['../pages/consult/docImgList'], resolve) //
const docImgReply = resolve => require(['../pages/consult/docImgReply'], resolve) //
const docPhoneOrder = resolve => require(['../pages/consult/docPhoneOrder'], resolve) //
const docPhoneReply = resolve => require(['../pages/consult/docPhoneReply'], resolve) //
    //健康档案
const archiveIndex = resolve => require(['../pages/archive/archiveIndex'], resolve)
const banUser = resolve => require(['../pages/archive/banUser'], resolve)
const userDetail = resolve => require(['../pages/archive/userDetail'], resolve)
const uploadReport = resolve => require(['../pages/archive/uploadReport'], resolve)
const addReportList = resolve => require(['../pages/archive/addReportList'], resolve)
const erwm = resolve =>require(["../pages/test/erwm.vue"], resolve);
    //认证医师
const idenfail = resolve => require(['../pages/configdoc/idenfail'], resolve)
const docidenty = resolve => require(['../pages/configdoc/docidenty'], resolve)
const wechatFollow = resolve => require(['../otherpage/wechatFollow'], resolve)
    //下载页面
const download = resolve => require(['../otherpage/downloadApp'], resolve)
const date = resolve => require(['../otherpage/date'], resolve)
const saomadate = resolve => require(['../otherpage/saomadate'], resolve)
const appdownload = resolve => require(['../otherpage/appDownload'], resolve)
const vuecorper = resolve => require(['../components/vuecropper'], resolve)
const error = resolve => require(['../otherpage/404error.vue'], resolve)
const Activity = resolve => require(['../pages/activity/activity.vue'], resolve)
const ActivityRule = resolve => require(['../pages/activity/activityRule.vue'], resolve)
const MyGift = resolve => require(['../pages/activity/myGift.vue'], resolve)
const Accomplish = resolve => require(['../pages/activity/accomplish.vue'], resolve)
const Address = resolve => require(['../pages/activity/address.vue'], resolve)
const Coupon = resolve => require(['../pages/activity/coupon.vue'], resolve)
const CouponRecord = resolve => require(['../pages/activity/couponRecord.vue'], resolve)

//协议页
const agreement = r => require.ensure([], () => r(require('../components/agreement')), 'agreement')
const agreement2 = r => require.ensure([], () => r(require('../components/agreement2')), 'agreement2')
    //赠送卡片
const giftCard = resolve => require(['../pages/gift/giftCard.vue'], resolve)
const giftSuccess = resolve => require(['../pages/gift/giftSuccess.vue'], resolve)
    //消费列表
const payList = resolve => require(['../pages/pay/payList'], resolve) //充值卡包列表
const noPay = resolve => require(['../pages/pay/nopay'], resolve)
const payComplete = resolve => require(['../pages/pay/payComplete.vue'], resolve) //充值卡充值
const yue = resolve => require(['../pages/pay/yue'], resolve)
    //团购
const monthCard = resolve => require(['../pages/assemble/monthCard'], resolve) //返利月卡
const assemRecord = resolve => require(['../pages/assemble/assemRecord'], resolve) //购买记录
const assemRule = resolve => require(['../pages/assemble/assemRule'], resolve) //使用规则
const assemDetail = resolve => require(['../pages/assemble/assemDetail'], resolve) //拼团详情
const assemJoin = resolve => require(['../pages/assemble/assemJoin'], resolve) //加入拼团
const assemWxJoin = resolve => require(['../pages/assemble/assemWxJoin'], resolve) //加入拼团
const assemBuy = resolve => require(['../pages/assemble/assemBuy'], resolve) //购买拼团
    //健康排名
const ranking = resolve => require(['../pages/healthyrank/ranking'], resolve) //购买拼团
const explain = resolve => require(['../pages/healthyrank/explain'], resolve) //购买拼团
    //我的团队
const myTeam = resolve => require(['../pages/team/myTeam'], resolve)
const teamRule = resolve => require(['../pages/team/teamRule'], resolve)
const teamTOT = resolve => require(['../pages/team/teamTOT'], resolve)
const teamWx = resolve => require(['../pages/team/teamWx'], resolve)
const teamCheck = resolve => require(['../pages/team/teamCheck'], resolve)
const teamAgent = resolve => require(['../pages/team/teamAgent'], resolve)
const teamHow = resolve => require(['../pages/team/teamHow'], resolve)
const teamShare = resolve => require(['../pages/team/teamShare'], resolve)
const teamFans = resolve => require(['../pages/team/teamFans'], resolve)
const testWx = resolve => require(['../pages/test/testWx'], resolve)
const QRCodeOver = resolve => require(['../pages/team/components/QRCodeOver'], resolve)
    //新人激励卡
const saleBuy = resolve => require(['../pages/business/saleBuy'], resolve) //购买新人激励卡
const saleRule = resolve => require(['../pages/business/saleRule'], resolve) //新人激励卡规则
const saleJob = resolve => require(['../pages/business/saleJob'], resolve) //新人激励卡任务
const saleRecord = resolve => require(['../pages/business/saleRecord'], resolve) //新人激励卡任务
const saleHome = resolve => require(['../pages/business/saleHome'], resolve) //拼团首页
const saleCheck = resolve => require(['../pages/business/saleCheck'], resolve) //拼团登录
const saleCode = resolve => require(['../pages/business/saleCode'], resolve) //拼团验证码
const saleMessage = resolve => require(['../pages/business/saleMessage'], resolve) //拼团完善资料
const saleMake = resolve => require(['../pages/business/saleMake'], resolve) //拼团二维码生成
const saleShare = resolve => require(['../pages/business/saleShare'], resolve) //拼团分享
    //扬帆起航卡
const newdBuy = resolve => require(['../pages/newcard/newdBuy'], resolve) //购买新人激励卡
const newdRule = resolve => require(['../pages/newcard/newdRule'], resolve) //新人激励卡规则
const newdJob = resolve => require(['../pages/newcard/newdJob'], resolve) //新人激励卡任务
const newdRecord = resolve => require(['../pages/newcard/newdRecord'], resolve) //新人激励卡任务
const newdCheck = resolve => require(['../pages/newcard/newdCheck'], resolve) //拼团登录
    //错误页面
const errBind = resolve => require(['../otherpage/errBind.vue'], resolve) //新人激励卡规则
    //测试页面
const Hello = resolve => require(['../components/HelloWorld.vue'], resolve)
const ahBuy = resolve => require(['../pages/anhui/ahBuy.vue'], resolve)
const ahRecord = resolve => require(['../pages/anhui/ahRecord.vue'], resolve)
const ahJob = resolve => require(['../pages/anhui/ahJob.vue'], resolve)
const ahVisit = resolve => require(['../pages/anhui/ahVisit.vue'], resolve)
const policy = resolve => require(['../components/policy.vue'], resolve)
const iospolicy = resolve => require(['../otherpage/iospolicy.vue'], resolve)
    //验证
const LoginIndex = resolve => require(['../../src/pages/login/loginIndex'], resolve);
//完善信息
const selfPersonal = resolve => require(['../pages/selfseek/selfPersonal.vue'], resolve)
const selfMessage = resolve => require(['../pages/selfseek/selfMessage.vue'], resolve)
    //山东
const shareHealthGift = resolve => require(['../pages/shandong/shareHealthGift.vue'], resolve)
const getHealthGift = resolve => require(['../pages/shandong/getHealthGift.vue'], resolve)
const failHealthGift = resolve => require(['../pages/shandong/failHealthGift.vue'], resolve)
    //会员权益
const myVip = resolve => require(['../pages/vipright/myVip.vue'], resolve)
const vipRecord = resolve => require(['../pages/vipright/vipRecord.vue'], resolve)
const yearVip = resolve => require(['../pages/vipright/yearVip.vue'], resolve)
const monthVip = resolve => require(['../pages/vipright/monthVip.vue'], resolve)
    //展业优惠
const discountShare = resolve => require(['../pages/exhibition/discountShare.vue'], resolve)
const savewx = resolve => require(['../components/savewx.vue'], resolve)
//客服
const waiter = resolve => require(['../pages/waiter/waiter'], resolve)
Vue.use(Router)
const router = new Router({
    mode: 'history',
    base: '/',
    routes: [{
            path: '/',
            redirect: '/login/index'
        },
        //微信登录
        {
            path: '/login/index',
            component: LoginIndex,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '登录',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            },
        },
        //缺省页
        {
            path: '/making',
            component: making,
            meta: {
                title: '',
            }
        },
        {
            path: '/hello',
            component: Hello,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录
            },
        },
        {
            path: '/test/wxsaofail',
            component: testfail,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '添加好友扫码失败',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            },
        },
        // 协议页1  法律声明及政策
        {
            path: '/agreement/law',
            component: agreement,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '协议',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            },
        },
        // 协议页2 服务协议
        {
            path: '/agreement/service',
            component: agreement2,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '服务协议',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            },
        },
        {
            path: '/comment/reply',
            component: commentReply,
            meta: {
                title: '文章评论',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        {
            path: '/home/content/:id',
            component: content,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '分享文章',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //首页
        {
            path: '/home',
            component: Home,
            meta: {
                title: '首页',
            },
        },
        //文章
        {
            path: '/home/article',
            component: homearticle,
            meta: {
                title: '文章列表'
            },

        },
        //健康报告
        {
            path: '/new/myReport',
            //component: newReport,
            component: Report,
            meta: {
                title: '健康报告',
            }
        },
        {
            path: '/send/report',
            //component: sendReport,
            component: Report,
            meta: {
                title: '赠送报告',
            }
        },
        {
            path: '/new/otherReport',
            //component: newReportPlan,
            component: Report,
            meta: {
                title: '他人报告',
            }
        },
        {
            path: "/test/erwm",
            component: erwm,
            meta: {
                title: "关注公众号"
            }
        },
        // {
        //     path: '/new/report',
        //     component: Report,
        //     meta: {
        //         title: '新版健康报告',
        //     }
        // },
        {
            path: '/test/wxsaoinfo',
            component: wxsaoInfo,
            meta: {
                title: '完善信息',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            },
        },
        //评估-用户列表
        {
            path: '/test/userList',
            name: 'userList',
            component: testUserList,
            meta: {
                title: '用户列表'
            },
        },
        {
            path: '/test/back',
            component: testBack,
            meta: {
                title: '用户列表'
            },
        },
        {
            path: '/test/myreport',
            component: testmyReport,
            meta: {
                title: '报告列表'
            },
        },
        // 评估-报告列表
        {
            path: '/test/reportList',
            component: reportList,
            meta: {
                title: '报告列表'
            },
        },
        //评估-用户添加方式(扫码添加)
        {
            path: '/test/wxsao',
            component: testWxsao,
            meta: {
                title: '用户扫码添加',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //用户信息
        {
            path: '/test/usernews',
            component: testuserNews,
            meta: {
                title: '用户列表个人信息'
            }
        },
        //评估-编辑用户
        {
            path: '/test/useredit/:Id',
            component: userEdit,
            meta: {
                title: '评估-编辑用户'
            }
        },
        {
            path: '/test/wanshan',
            component: wanShan,
        },
        //评估-用户评估记录
        {
            path: '/test/record',
            component: testRecord,
            meta: {
                title: '我的评估记录'
            }
        },
        //评估-用户自己评估记录
        {
            path: '/test/myReList',
            component: testReList,
            meta: {
                title: '我的报告列表'
            }
        },
        //评估-开始评估 提示页面
        {
            path: '/test/home',
            component: testHome,
            meta: {
                title: '开始评估',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //评估-开始评估 提示页面
        {
            path: '/test/transition',
            component: testTransition,
            meta: {
                title: '进入问诊阶段',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //评估-开始评估  照片页type 1-面诊 2-舌诊
        {
            path: '/test/tipImg/:type',
            component: testTipImg,
            meta: {
                title: '开始拍照',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //评估-问诊
        {
            path: '/test/question',
            component: testQuestion,
            meta: {
                title: '问诊',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //个人中心主页
        {
            path: '/personal',
            component: personal,
            meta: {
                title: '个人中心'
            }
        },
        //我的公司二维码
        {
            path: '/company',
            component: company,
            meta: {
                title: '我的公司二维码',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //公司验证
        {
            path: '/company/check',
            component: companyCheck,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '公司认证',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            },
        },
        //我的公司二维码
        {
            path: '/company/after',
            component: companyAfter,
            meta: {
                title: '我的公司二维码',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //健康排名
        {
            path: '/rank/explain',
            component: explain,
            meta: {
                title: '健康排名规则',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //健康排名规则
        {
            path: '/healthy/rank',
            component: ranking,
            meat: {
                title: '健康排名',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //个人中心设置
        {
            path: '/personal/set',
            component: personalSet,
            meta: {
                title: '个人中心设置'
            }
        },
        //关于泉脉
        {
            path: '/otherpage/quanmai',
            component: quanmai,
            meta: {
                title: '关于泉脉'
            }
        },
        //授权管理
        {
            path: '/personal/manager',
            component: manager,
            meta: {
                title: '授权管理'
            }
        },
        //支付页面
        {
            path: '/consult/pay/:orderId',
            component: pay,
            meta: {
                title: '支付页面',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                isShow: true //添加该字段，表示进入这个路由不显示健康排名

            }
        },
        {
            path: '/pay/weixin',
            component: payWeixin,
            meta: {
                title: '支付完成'
            }
        },

        //我的卡包
        {
            path: '/consult/mycard', //1有效卡，2无效卡
            component: Mycard,
            meta: {
                title: '我的卡包'
            }
        },
        //我的无效卡包
        {
            path: '/consult/failcard', //1有效卡，2无效卡
            component: MyFailCard,
            meta: {
                title: '我的无效卡包'
            }
        },
        //兑换充值码
        {
            path: "/consult/paycard",
            component: payCard,
            meta: {
                title: '兑换充值码'
            }
        },
        //赠送我的卡包
        {
            path: '/consult/sendcard',
            component: sendCard,
            meta: {
                title: '赠送我的卡'
            }
        },
        //卡使用记录
        {
            path: '/consult/cardrecord',
            component: cardrecord,
            meta: {
                title: '充值卡记录'
            }
        },
        //健康趋势图
        {
            path: '/find/chart',
            component: healthChart,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '健康趋势图',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        // 健康趋势页面
        {
            path: '/iosandroid',
            component: iosandroid,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '健康趋势页面',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //帮助与反馈
        {
            path: '/personal/helpfeed',
            component: helpFeed,
            meta: {
                title: '帮助与反馈'
            }
        },
        //反馈
        {
            path: '/personal/feedback',
            component: feedBack,
            meta: {
                title: '反馈'
            }
        },
        //反馈问题
        {
            path: '/personal/feedquestion',
            component: feedQuestion,
            meta: {
                title: '反馈问题'
            }
        },
        // 二维码扫描后页面
        {
            path: '/RQCode/:saleId',
            component: QRCodeOver,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '二维码扫描后页面'
            }
        },
        //个人中心修改信息页面（医生）修改个人资料
        {
            path: '/personal/detailsDoc',
            component: psDetailsDoc,
            meta: {
                title: '医生修改个人资料'
            }
        },
        //个人中心修改信息页面（医生）修改医师资料
        {
            path: '/personal/detailsDoc2',
            component: psDetailsDoc2,
            meta: {
                title: '修改医师资料'
            }
        },
        //个人中心修改咨询费用（医生）
        {
            path: '/personal/price',
            component: personalDocPrice,
            meta: {
                title: '个人中心修改咨询费用'
            }
        },
        //任务中心
        {
            path: '/jifen/jobcenter',
            component: jobcenter,
            meta: {
                title: '任务中心'
            }
        },
        //我的积分
        {
            path: '/jifen/integration',
            component: Integration,
            meta: {
                title: '我的积分'
            }
        },
        //积分规则
        {
            path: '/jifen/Interule',
            component: Interule,
            meta: {
                title: '积分规则'
            }
        },

        //健康咨询首页
        {
            path: '/consult/index',
            component: cstIndex,
            meta: {
                title: '健康咨询首页'
            }
        },
        //搜索页面
        {
            path: '/consult/search',
            component: docSearch,
            meta: {
                title: '搜索页面'
            }
        },
        //我的咨询页面
        {
            path: '/consult/my',
            component: myCst,
            meta: {
                title: '我的咨询页面'
            }
        },
        //咨询 医生详情页面
        {
            path: '/consult/docIndex',
            component: cstDocIndex,
        },
        //咨询 图文咨询
        {
            path: '/consult/imgCst',
            component: imgCst,
            meta: {
                title: '图文咨询'
            }
        },
        //咨询 电话咨询
        {
            path: '/consult/phoneCst',
            component: phoneCst,
            meta: {
                title: '电话咨询'
            }
        },
        //不需要支付页面
        {
            path: '/pay/nopay', //Message
            component: noPay,
            meta: {
                title: '不需要支付'
            }
        },
        //电话咨询（付款后页面）
        {
            path: '/consult/phoneOrder',
            component: phoneOrder,
            children: [
                //确认订单页面
                {
                    path: 'index/:orderId',
                    component: phoneOrderSubmit,
                    meta: {
                        title: '确认订单'
                    }
                },
                //确认订单  各状态页面
                {
                    path: 'type/:orderId',
                    component: phoneOrderType,
                    meta: {
                        title: '确认订单'
                    }
                },
            ]
        },
        //健康回复页面
        {
            path: '/consult/doc/list',
            component: docCstList,
            meta: {
                title: '健康回复'
            }
        },
        //图文咨询列表页面
        {
            path: '/consult/doc/imgList',
            component: docImgList,
            meta: {
                title: '图文咨询列表'
            }
        },
        //图文咨询聊天页
        {
            path: '/consult/doc/imgReply',
            component: docImgReply,
            meta: {
                title: '图文咨询聊天'
            }
        },
        //医生电话订单页面
        {
            path: '/consult/doc/phoneOrder',
            component: docPhoneOrder,
            meta: {
                title: '医生电话订单'
            }
        },
        //医生订单回复页面
        {
            path: '/consult/doc/phoneReply/:orderId',
            component: docPhoneReply,
            meta: {
                title: '医生订单回复'
            }
        },

        // 健康档案  首页
        {
            path: '/archive/index',
            component: archiveIndex,
            meta: {
                title: '健康档案首页'
            }
        },
        // 健康档案  绑定用户 type 1-添加  2-编辑
        {
            path: '/archive/add/:type',
            component: banUser,
            meta: {
                title: '健康档案绑定用户'
            }
        },
        // 健康档案  用户首页
        {
            path: '/archive/detail',
            component: userDetail,
            meta: {
                title: '健康档案用户首页'
            }
        },
        // 健康档案  上传的评估报告 type 1-报告  2-化验单
        {
            path: '/archive/reportList/:type',
            component: uploadReport,
            meta: {
                title: '健康档案上传的评估报告'
            }
        },
        // 健康档案  添加、查看评估报告 type1 报告 2 化验单 status 1-上传  2-查看
        {
            path: '/archive/addReportList/:type/:status',
            component: addReportList,
            meta: {
                title: '健康档案报告'
            }
        },
        //个人中心修改信息页面
        {
            path: '/personal/details',
            component: psDetails,
            meta: {
                title: '个人中心修改信息页面'
            }
        },
        // 微信关注页面
        {
            path: '/wechat/follow',
            component: wechatFollow,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '微信关注'
            },
        },
        // 下载页面
        {
            path: '/page/download',
            component: download,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            },
        },
        // 下载页面
        {
            path: '/yzl/download',
            component: appdownload,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            },
        },
        //我的团队
        {
            path: '/my/team',
            component: myTeam,
            meta: {
                title: '代理商'
            }
        },
        //我的团队规则
        {
            path: '/team/rule',
            component: teamRule,
            meta: {
                title: '代理商规则'
            }
        },
        //我的团队规则,coc
        {
            path: '/team/tot',
            component: teamTOT,
            meta: {
                title: 'C2C规则'
            }
        },
        //如何成为我的团队
        {
            path: '/team/how',
            component: teamHow,
            meta: {
                title: '如何成为代理商'
            }
        },
        //我的团队规则
        {
            path: '/team/fans',
            component: teamFans,
            meta: {
                title: '粉丝规则'
            }
        },
        //我的团队二维码
        {
            path: '/team/wx',
            component: teamWx,
            meta: {
                title: '粉丝二维码',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的


            }
        },
        //team分享
        {
            path: '/team/share/:userId/:type/:token',
            component: teamShare,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '代理商粉丝分享',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        {
            path: '/team/agent/:parentUserId',
            component: teamAgent,
        },
        {
            path: '/team/check',
            component: teamCheck,
        },
        // 消费列表 （充值）
        {
            path: '/pay/list',
            component: payList,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '充值卡充值列表',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        // 支付宝支付完成页面
        {
            path: '/pay/complete',
            component: paid,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '支付完成',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        // 支付完成页面
        {
            path: '/pay/over',
            component: payComplete,
            meta: {
                title: '支付完成'
            }
        },
        // 余额页
        {
            path: '/yue/:type',
            component: yue,
            meta: {
                title: '余额'
            }
        },
        // 报告详情页
        {
            path: '/test/reportDetails', //?code=
            component: reportdetails,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '报告详情页',
                isShow: true
            },
        },
        // 报告详情页2
        {
            path: '/test/reportDetails2', //?code=
            component: reportdetails2,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '报告详情',
                isShow: true
            },
        },
        // 用户端扫码完善资料页面
        {
            path: '/test/wxqrcomplete',
            component: qrUserComplete,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '扫码完善资料',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //用户端扫码完成页面
        {
            path: '/test/wxqrover',
            component: qrUserOver,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '客户端扫码完成',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        {
            path: '/test/wx',
            component: testWx,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        //身份上传
        {
            path: '/configdoc/docidenty',
            component: docidenty,
            meta: {
                title: '医生身份认证'
            }

        },
        //审核失败
        {
            path: '/configdoc/idenfail',
            component: idenfail,
            meta: {
                title: '医生身份审核失败'
            }

        },
        {
            path: '/vuecorper',
            component: vuecorper,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: '/gift/card/:cardId/:fromUserId',
            component: giftCard,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '卡片分享',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        {
            path: '/gift/success',
            component: giftSuccess,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '领取卡片成功',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        {
            path: '/test/search',
            component: testSearch,
            meta: {
                title: '用户列表搜索'
            }

        },
        //拼团
        {
            path: '/assemble/mothcard', //返利月卡
            component: monthCard,
            meta: {
                title: '返利月卡任务'
            }
        },
        {
            path: '/assemble/record', //拼团
            component: assemRecord,
            meta: {
                title: '拼团记录'
            }

        },
        {
            path: '/assemble/buy', //拼团
            component: assemBuy,
            meta: {
                title: '购买返利月卡'
            }

        },
        {
            path: '/assemble/rule', //规则
            component: assemRule,
            meta: {
                title: '拼团规则'
            }

        },
        {
            path: '/assemble/detail', //拼团详情
            component: assemDetail,
            mrta: {
                title: '拼团详情'
            }

        },
        {
            path: '/assemble/join', //加入拼团
            component: assemJoin,
            meta: {
                title: '加入拼团'
            }

        },
        {
            path: '/assemble/wxjoin', //分享加入拼团
            component: assemWxJoin,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '分享加入拼团'
            }
        },
        {
            path: '/assemble/wxjoin/:teamId', //分享加入拼团
            component: assemWxJoin,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '分享加入拼团'
            }
        },
        //简易报告
        {
            path: '/test/reportPlan', //?code=
            component: ReportPlan,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '健康方案',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //新人激励卡购买
        {
            path: '/sale/buy/:cardId/:sellerId',
            component: saleBuy,
            meta: {
                title: '新人激励卡购买',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //新人激励卡规则
        {
            path: '/sale/rule',
            component: saleRule,
            meta: {
                title: '新人激励卡规则',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },

        //新人激励卡购买
        {
            path: '/newd/buy/:SellerId',
            component: newdBuy,
            meta: {
                title: '新人激励卡购买',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //新人激励卡规则
        {
            path: '/newd/rule',
            component: newdRule,
            meta: {
                title: '新人激励卡规则',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //新人激励卡任务
        {
            path: '/newd/job',
            component: newdJob,
            meta: {
                title: '新人激励卡任务',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        //手机验证
        {
            path: '/newd/check/:SellerId',
            component: newdCheck,
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
                title: '新人卡验证',
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        {
            path: '/newd/record', //拼团
            component: newdRecord,
            meta: {
                title: '新人激励卡记录',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        //新人激励卡任务
        {
            path: '/sale/job',
            component: saleJob,
            meta: {
                title: '新人激励卡任务',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: '/sale/record', //拼团
            component: saleRecord,
            meta: {
                title: '新人激励卡记录',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: '/sale/home', //拼团
            component: saleHome,
            meta: {
                title: '新人激励卡首页',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: '/sale/check/:cardId/:sellerId', //拼团
            component: saleCheck,
            meta: {
                title: '新人激励卡注册',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: '/sale/code/:cardId/:sellerId', //拼团
            component: saleCode,
            meta: {
                title: '新人激励卡验证码',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: '/sale/message', //拼团
            component: saleMessage,
            meta: {
                title: '新人激励卡登录',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: '/sale/share', //拼团
            component: saleShare,
            meta: {
                title: '新人激励卡分享',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: '/sale/make', //拼团
            component: saleMake,
            meta: {
                title: '新人激励卡生成',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: '/err/bind', //拼团
            component: errBind,
            meta: {
                title: '用户锁定',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: '/ah/buy',
            component: ahBuy,
            meta: {
                title: '安徽自主经营卡',
            }
        },
        {
            path: '/ah/record', //拼团
            component: ahRecord,
            meta: {
                title: '安徽自主经营卡',
            }
        },
        {
            path: '/ah/visit', //拼团
            component: ahVisit,
            meta: {
                title: '安徽自主经营卡',

            }
        },
        {
            path: '/ah/job', //拼团
            component: ahJob,
            meta: {
                title: '安徽自主经营卡',
            }
        },
        {
            path: '/policy', //拼团
            component: policy,
            meta: {
                title: '政策',
            }
        },
        {
            path: '/iospolicy', //拼团
            component: iospolicy,
            meta: {
                title: '政策',
            }
        },
        {
            path: '/self/message',
            component: selfMessage,
            meta: {
                title: '设置头像',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的

            }
        },
        {
            path: '/activity', //拼团
            component: Activity,
            meta: {
                title: '活动',
            }
        },
        {
            path: '/activity/rule', //拼团
            component: ActivityRule,
            meta: {
                title: '活动',
            }
        },
        {
            path: '/activity/mygift', //拼团
            component: MyGift,
            meta: {
                title: '我的领取',
            }
        },
        {
            path: '/activity/accomplish',
            component: Accomplish,
            meta: {
                title: '物流信息',
            }
        },
        {
            path: '/test/userBack',
            component: testUserBack,
            meta: {
                title: '用户',
            }
        },
        {
            path: '/activity/address',
            component: Address,
            meta: {
                title: '地址',
            }
        },
        {
            path: '/activity/coupon',
            component: Coupon,
            meta: {
                title: '优惠券',
            }
        },
        {
            path: '/coupon/record',
            component: CouponRecord,
            meta: {
                title: '记录',
            }
        },
        {
            path: '/shand/sharegift/:id/:code',
            component: shareHealthGift,
            meta: {
                title: '分享健康红包',
            }
        },
        {
            path: '/shand/getgift',
            component: getHealthGift,
            meta: {
                title: '分享健康红包',
            }
        },
        {
            path: '/shand/failgift',
            component: failHealthGift,
            meta: {
                title: '领取健康卡包',
            }
        },
        {
            path: '/my/vip',
            component: myVip,
            meta: {
                title: '我的会员'
            }
        },
        {
            path: '/year/vip',
            component: yearVip,
            meta: {
                title: '年卡会员'
            }
        },
        {
            path: '/month/vip',
            component: monthVip,
            meta: {
                title: '月卡会员'
            }
        },
        {
            path: '/vip/record',
            component: vipRecord,
            meta: {
                title: '会员记录'
            }
        },
        {
            path: '/date',
            component: date,
            meta: {
                title: '会员记录'
            }
        },
        {
            path: '/self/personal',
            component: selfPersonal,
            meta: {
                title: '完善信息',
                requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: '/discount/share/:actionId/:uid',
            component: discountShare,
            meta: {
                title: '展业优惠详情',
            }
        },
        {
            path: '/saoma/date',
            component: saomadate,
        },
        {
            path: '/save/wx',
            component: savewx,
        },
        //客服
        {
            path: '/waiter',
            component: waiter
        },
    ]
})
router.afterEach(to => {
    if (gtag) {
        gtag('config', 'UA-139122490-5', { 'page_path': to.fullPath })
    }
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js